import {
  EmployeeCountRange,
  PilotLeadPriority,
  PilotLeadSource,
  PilotLeadStatus,
  LeadTaskType,
} from '@/models/pilot-crm.model';

export const EMPLOYEE_COUNT_RANGES: EmployeeCountRange[] = [
  '1-9',
  '10-49',
  '50-199',
  '200-999',
  '1000+',
];

export const PILOT_LEAD_SOURCES: PilotLeadSource[] = [
  'pilot_page',
  'cold_email',
  'referral',
  'inbound',
  'partner',
  'google_places',
  'other',
];

export const PILOT_LEAD_STATUSES: PilotLeadStatus[] = [
  'new',
  'invited',
  'replied',
  'call_booked',
  'accepted',
  'onboarding',
  'live',
  'not_fit',
  'paused',
  'no_response',
];

export const PILOT_LEAD_PRIORITIES: PilotLeadPriority[] = ['low', 'normal', 'high'];

export const PILOT_TASK_TYPES: LeadTaskType[] = [
  'follow_up',
  'schedule_call',
  'send_docs',
  'onboarding_step',
  'other',
];
